import { render, staticRenderFns } from "./BannerCarousel.vue?vue&type=template&id=3827680c&scoped=true"
import script from "./BannerCarousel.vue?vue&type=script&lang=js"
export * from "./BannerCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3827680c",
  null
  
)

export default component.exports